import { render, staticRenderFns } from "./TheInfoCard.vue?vue&type=template&id=5f99a345&scoped=true"
import script from "./TheInfoCard.vue?vue&type=script&lang=js"
export * from "./TheInfoCard.vue?vue&type=script&lang=js"
import style0 from "./TheInfoCard.vue?vue&type=style&index=0&id=5f99a345&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f99a345",
  null
  
)

export default component.exports